export enum LocaleCode {
    en_US = 'en-US',
    ja_JP = 'ja-JP',
}
